import type { Furniture } from './Types';

export const furnituresList: Record<number, Furniture> = {
	// Chairs
	1: {
		id: 1,
		name: 'Chair 1',
		width: 30,
		height: 30,
		type: 'chair',
		img: './images/furnitures/chair1.svg',
	},
	2: {
		id: 2,
		name: 'Chair 3',
		width: 30,
		height: 30,
		type: 'chair',
		img: './images/furnitures/char3.svg',
	},
	3: {
		id: 3,
		name: 'Chair 4',
		width: 30,
		height: 30,
		type: 'chair',
		img: './images/furnitures/chair4.svg',
	},
	4: {
		id: 4,
		name: 'Chair 5',
		width: 30,
		height: 30,
		type: 'chair',
		img: './images/furnitures/chair5.svg',
	},
	5: {
		id: 5,
		name: 'Chair 6',
		width: 30,
		height: 30,
		type: 'chair',
		img: './images/furnitures/chair6.svg',
	},
	6: {
		id: 6,
		name: 'Chair 7',
		width: 30,
		height: 30,
		type: 'chair',
		img: './images/furnitures/chair7.svg',
	},
	7: {
		id: 7,
		name: 'Office Chair',
		width: 35,
		height: 35,
		type: 'chair',
		img: './images/furnitures/officeChair.svg',
	},
	8: {
		id: 8,
		name: 'Office Chair 2',
		width: 35,
		height: 35,
		type: 'chair',
		img: './images/furnitures/officeChair2.svg',
	},

	// Tables
	10: {
		id: 10,
		name: 'Dining Table with Chairs',
		width: 140,
		height: 100,
		type: 'table',
		img: './images/furnitures/diningTableWithChairs.svg',
	},
	11: {
		id: 11,
		name: 'Table Dining',
		width: 120,
		height: 80,
		type: 'table',
		img: './images/furnitures/tableDining.svg',
	},
	12: {
		id: 12,
		name: 'Table',
		width: 100,
		height: 60,
		type: 'table',
		img: './images/furnitures/table.svg',
	},
	13: {
		id: 13,
		name: 'Small Table',
		width: 50,
		height: 50,
		type: 'table',
		img: './images/furnitures/smallTable.svg',
	},
	14: {
		id: 14,
		name: 'Round Table',
		width: 80,
		height: 80,
		type: 'table',
		img: './images/furnitures/roundTable.svg',
	},
	15: {
		id: 15,
		name: 'Desk',
		width: 100,
		height: 60,
		type: 'table',
		img: './images/furnitures/desk.svg',
	},
	16: {
		id: 16,
		name: 'Corner Desk',
		width: 90,
		height: 90,
		type: 'table',
		img: './images/furnitures/cornerDesk.svg',
	},

	// Couches
	17: {
		id: 17,
		name: 'Couch',
		width: 110,
		height: 50,
		type: 'couch',
		img: './images/furnitures/couch.svg',
	},
	18: {
		id: 18,
		name: 'Couch 1',
		width: 80,
		height: 40,
		type: 'couch',
		img: './images/furnitures/couch1.svg',
	},
	19: {
		id: 19,
		name: 'Couch 3',
		width: 100,
		height: 50,
		type: 'couch',
		img: './images/furnitures/couch3.svg',
	},
	20: {
		id: 20,
		name: 'Sofa 1',
		width: 70,
		height: 40,
		type: 'couch',
		img: './images/furnitures/sofa1.svg',
	},
	21: {
		id: 21,
		name: 'Sofa 2',
		width: 70,
		height: 40,
		type: 'couch',
		img: './images/furnitures/sofa2.svg',
	},
	22: {
		id: 22,
		name: 'Corner Couch',
		width: 120,
		height: 120,
		type: 'couch',
		img: './images/furnitures/corner couch.svg',
	},
	23: {
		id: 23,
		name: 'Couch 5',
		width: 100,
		height: 50,
		type: 'couch',
		img: './images/furnitures/couch5.svg',
	},
	24: {
		id: 24,
		name: 'Sofa 4',
		width: 80,
		height: 45,
		type: 'couch',
		img: './images/furnitures/sofa4.svg',
	},
	25: {
		id: 25,
		name: 'Sofa 5',
		width: 90,
		height: 45,
		type: 'couch',
		img: './images/furnitures/sofa5.svg',
	},
	26: {
		id: 26,
		name: 'Small Corner Couch',
		width: 70,
		height: 70,
		type: 'couch',
		img: './images/furnitures/smallCornerCouch.svg',
	},

	// Kitchen
	27: {
		id: 27,
		name: 'Sink',
		width: 60,
		height: 40,
		type: 'kitchen',
		img: './images/furnitures/sink.svg',
	},
	28: {
		id: 28,
		name: 'Sink 2',
		width: 50,
		height: 40,
		type: 'kitchen',
		img: './images/furnitures/sink 2.svg',
	},
	29: {
		id: 29,
		name: 'Stove',
		width: 60,
		height: 60,
		type: 'kitchen',
		img: './images/furnitures/stove.svg',
	},
	30: {
		id: 30,
		name: 'Kitchen Cabinet',
		width: 80,
		height: 40,
		type: 'kitchen',
		img: './images/furnitures/kitchen cabinet.svg',
	},
	31: {
		id: 31,
		name: 'Kitchen Cabinet 2',
		width: 80,
		height: 40,
		type: 'kitchen',
		img: './images/furnitures/kitchen cabinet 2.svg',
	},
	32: {
		id: 32,
		name: 'Double Sink',
		width: 80,
		height: 40,
		type: 'kitchen',
		img: './images/furnitures/doubleSink.svg',
	},

	// Bathroom
	33: {
		id: 33,
		name: 'Toilet',
		width: 40,
		height: 50,
		type: 'bathroom',
		img: './images/furnitures/toilet.svg',
	},
	34: {
		id: 34,
		name: 'Bathtub',
		width: 80,
		height: 40,
		type: 'bathroom',
		img: './images/furnitures/bathtub.svg',
	},
	35: {
		id: 35,
		name: 'Toilet 2',
		width: 40,
		height: 50,
		type: 'bathroom',
		img: './images/furnitures/toilet 2.svg',
	},
	36: {
		id: 36,
		name: 'Toilet 3',
		width: 40,
		height: 50,
		type: 'bathroom',
		img: './images/furnitures/toilet 3.svg',
	},
	37: {
		id: 37,
		name: 'Bathtub 2',
		width: 80,
		height: 40,
		type: 'bathroom',
		img: './images/furnitures/bathtub 2.svg',
	},
	38: {
		id: 38,
		name: 'Jacuzzi',
		width: 100,
		height: 100,
		type: 'bathroom',
		img: './images/furnitures/jakuzi.svg',
	},

	// Beds
	40: {
		id: 40,
		name: 'Bed 2',
		width: 80,
		height: 120,
		type: 'bed',
		img: './images/furnitures/Bed2.svg',
	},
	41: {
		id: 41,
		name: 'Bed 3',
		width: 80,
		height: 120,
		type: 'bed',
		img: './images/furnitures/bed3.svg',
	},
	44: {
		id: 44,
		name: 'Double Bed',
		width: 100,
		height: 140,
		type: 'bed',
		img: './images/furnitures/doubleBed.svg',
	},

	// Cabinets
	45: {
		id: 45,
		name: 'Cabinet',
		width: 60,
		height: 40,
		type: 'cabinet',
		img: './images/furnitures/cabinet.svg',
	},
	46: {
		id: 46,
		name: 'Cabinet 2',
		width: 60,
		height: 40,
		type: 'cabinet',
		img: './images/furnitures/cabinet 2.svg',
	},
	47: {
		id: 47,
		name: 'Cabinet 3',
		width: 60,
		height: 40,
		type: 'cabinet',
		img: './images/furnitures/cabinet 3.svg',
	},
	48: {
		id: 48,
		name: 'Small Cabinet',
		width: 40,
		height: 30,
		type: 'cabinet',
		img: './images/furnitures/smallCabinet.svg',
	},
	49: {
		id: 49,
		name: 'Long Cabinet',
		width: 100,
		height: 40,
		type: 'cabinet',
		img: './images/furnitures/longCabinet.svg',
	},
	50: {
		id: 50,
		name: 'Lamp Cabinet',
		width: 50,
		height: 35,
		type: 'cabinet',
		img: './images/furnitures/lampCabinet.svg',
	},
	51: {
		id: 51,
		name: 'TV Cabinet',
		width: 120,
		height: 40,
		type: 'cabinet',
		img: './images/furnitures/tvCabinet.svg',
	},
	52: {
		id: 52,
		name: 'TV Cabinet 2',
		width: 120,
		height: 40,
		type: 'cabinet',
		img: './images/furnitures/tvCabinet 2.svg',
	},

	// Electronics
	53: {
		id: 53,
		name: 'Airflow',
		width: 50,
		height: 50,
		type: 'electronics',
		img: './images/furnitures/airflow.svg',
	},
	60: {
		id: 46,
		name: 'TV',
		width: 60,
		height: 40,
		type: 'electronics',
		img: './images/furnitures/tv.svg',
	},

	// Plants
	58: {
		id: 58,
		name: 'Small Plant',
		width: 25,
		height: 25,
		type: 'plants',
		img: './images/furnitures/plant1.svg',
	},
	59: {
		id: 59,
		name: 'Medium Plant',
		width: 30,
		height: 30,
		type: 'plants',
		img: './images/furnitures/plant2.svg',
	},
};
